import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-bloco-animado',
    templateUrl: './bloco-animado.component.html',
    styleUrls: ['./bloco-animado.component.scss'],
    animations: [
        trigger('animacao-bloco', [
            state('normal', style({})),
            state('modificado', style({ 'border-radius': '10px 10px 0px 0px' })),
            transition('normal => modificado', animate('100ms 0s ease-in')),
            transition('modificado => normal', animate('100ms 0s ease-out'))
        ]),
        trigger('animacao-bloco-interno', [
            state('hidden', style({ display: 'none' })),
            state('visible', style({ display: 'block', 'border-top': '1px', 'margin-bottom': '10px' })),
            transition('hidden => visible', animate('100ms 0s ease-in')),
            transition('visible => hidden', animate('100ms 0s ease-out'))
        ])
    ],
    standalone: false
})
export class BlocoAnimadoComponent implements OnInit {

  @Input() title: string
  @Input() estaAberto: boolean = false

  @Output() eventoClick = new EventEmitter()

  animacaoBloco: string = "normal"
  animacaoBlocoInterno: string = "hidden"

  constructor() { }

  ngOnInit() {
  }

  click() {
    // this.animacaoBlocoInterno = this.animacaoBlocoInterno === "hidden" ? "visible" : "hidden"
    // this.animacaoBloco = this.animacaoBloco === "normal" ? "modificado" : "normal"
    this.eventoClick.emit(this.title);
  }

  ngOnChanges() {
    this.animacaoBlocoInterno = !this.estaAberto ? "hidden" : "visible"
    this.animacaoBloco = !this.estaAberto ? "normal" : "modificado"
  }

}
